import { Component } from '@angular/core';

@Component({
    selector: "Loader",
    template: require('./loader.component.html'),
    styles: [
        require('./loader.component.css')
    ]
})

export class Loader {
}